<app-common-loader *ngIf="carregando"></app-common-loader>

<div class="modal-backdrop" (click)="fecharModal()"></div>
<div class="shared-container">
  <div class="modal-container">
    <div class="modal-header">
      <div class="d-flex box-header">
        <h2 class="modal-title">Editar Tarefa</h2>
        <button class="btn-close" (click)="fecharModal()" type="button">
          x
        </button>
      </div>
      <p class="modal-subtitle">
        Modifique os detalhes da tarefa conforme necessário.
      </p>
    </div>
    <div class="modal-body">
      <label for="tarefa">Ação</label>
      <select id="tarefa" [(ngModel)]="actionID" class="form-control">
        <option value="" disabled>Selecione a ação</option>
        <option *ngFor="let t of tarefas" [value]="t.id.toString()">
          {{ t.description }}
        </option>
      </select>

      <label for="obra">Obra</label>
      <select id="obra" [(ngModel)]="workID" class="form-control">
        <option [value]="null" disabled>Selecione a obra</option>
        <option
          *ngFor="let obra of obras"
          [value]="obra.workID"
          [selected]="obra.isSelected"
        >
          {{ obra.workName }}
        </option>
      </select>

      <div class="date-time">
        <div>
          <label for="data">DATA </label>
          <input
            id="data"
            type="date"
            [(ngModel)]="data"
            class="form-control"
            [min]="today"
          />
        </div>
        <div>
          <label for="hora">HORA </label>
          <input
            id="hora"
            type="time"
            [(ngModel)]="hora"
            class="form-control"
          />
        </div>
      </div>

      <label for="responsavel">RESPONSÁVEL </label>
      <select id="responsavel" [(ngModel)]="responsibleID" class="form-control">
        <option value="" disabled>Selecione um responsável</option>
        <option *ngFor="let r of responsavel" [value]="r.id">
          {{ r.name }}
        </option>
      </select>

      <label for="anotacao">Anotação (opcional)</label>
      <textarea
        id="anotacao"
        [(ngModel)]="description"
        class="form-control"
        placeholder="Anotação de exemplo para esta tarefa"
      ></textarea>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-secondary btn-cancelar"
        type="button"
        (click)="fecharModal()"
      >
        Cancelar
      </button>
      <button
        class="btn btn-primary btn-criar"
        type="button"
        (click)="editarTarefa()"
      >
        Salvar alterações
      </button>
    </div>
  </div>
</div>
